module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 1")]), _vm._v(" Buchanan’s Boy – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Early Years")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 2")]), _vm._v(" The First Favourites – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esmé Stuart and the Earl of Huntly")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Devil on the Forth – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("King James and Witchcraft")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 4")]), _vm._v(" Above the Black Turnpike – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gowrie Conspiracy")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 5")]), _vm._v(" Two Mothers, One Wife – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elizabeth, Mary, Anne")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 6")]), _vm._v(" A Family Man – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The King’s Children and Cousin")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 7")]), _vm._v(" Shadows at the King’s Right Hand – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Royal Associates and the Path to the English Crown")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 8")]), _vm._v(" The King at Leisure – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poetry and the Hunt")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 9")]), _vm._v(" Lion Versus Unicorn – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Ill-Made Marriage of Scotland and England")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 10")]), _vm._v(" The Nation’s Second Scotsman – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rise and Fall of Robert Carr")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 11")]), _vm._v(" Steenie – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("George Villiers, Duke of Buckingham")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 12")]), _vm._v(" The Forerunner of Revenge – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Death of King James")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 13")]), _vm._v(" Solomon Weighed – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reputation and Legacy")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocbt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Illustration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and References")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0